import { AnyAction } from 'redux';

import { CUSTOMER_DETAIL_MEMBER_UPDATE } from './customer-detail-actions';

export interface CustomerDetailGlobalReducerState {
    isMember: boolean;
    memberSince?: Date | null;
}

export const initialCustomerDetailGlobalReducerState: CustomerDetailGlobalReducerState = {
    isMember: false,
};

export const customerDetailGlobalReducer = (
    state: CustomerDetailGlobalReducerState = initialCustomerDetailGlobalReducerState,
    action: AnyAction
): CustomerDetailGlobalReducerState => {
    switch (action.type) {
        case CUSTOMER_DETAIL_MEMBER_UPDATE:
            return {
                ...state,
                isMember: action['isMember'],
                memberSince: action['memberSince'],
            };
        default:
            return state;
    }
};
